import React, { useEffect, useState } from "react";
import { AgentProfile, Invitee } from "@closerplatform/spinner-openapi";
import { L10n } from "@fidget/common/i18n";
import commonStyles from "../../../containers/settings/settingsEditCommon.css";
import { useStore } from "../../../models";
import { LoadingState } from "../../HOC/withPreloading/types";
import { usePreloader, withPreloading } from "../../HOC/withPreloading/withPreloading";
import { BillingSummary } from "./components/billingSummary/billingSummary";
import { useAgentServices } from "../../../models/agentServices";

const BillingSettingsComponent = () => {
  const {
    currentUserStore: { planPrice, planCurrency, country, vatId }
  } = useStore();
  const { spinnerService } = useAgentServices();

  const { setLoadingState } = usePreloader();

  const [activeAgents, setActiveAgents] = useState<AgentProfile[]>([]);
  const [pendingAgents, setPendingAgents] = useState<Invitee[]>([]);

  const loadAgents = async () => {
    Promise.all([spinnerService.getAgentProfiles(), spinnerService.getPendingAgents()]).then(
      ([resultAgents, resultPendingAgents]) => {
        const resultActiveAgents = resultAgents.filter((agent) => agent.isActive);

        setActiveAgents(resultActiveAgents.filter((agent) => !agent.isBot));
        setPendingAgents(resultPendingAgents);
      }
    );
  };

  useEffect(() => {
    loadAgents()
      .then(() => setLoadingState(LoadingState.Loaded))
      .catch(() => setLoadingState(LoadingState.Error));
  }, []);

  return planPrice > 0 ? (
    <>
      <div className={commonStyles.title}>
        <L10n id={"settings.billing"} />
      </div>
      <div className={commonStyles.section}>
        <BillingSummary
          advisersCount={activeAgents.length + pendingAgents.length}
          planPrice={planPrice}
          planCurrency={planCurrency}
          country={country}
          vatId={vatId}
        />
      </div>
    </>
  ) : (
    <></>
  );
};

export const BillingSettings = withPreloading(BillingSettingsComponent);
